import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/roadside`;

export const roadsideAPI = {
  // Create roadside assistance request
  createRequest: async (requestData) => {
    const response = await axios.post(`${API_URL}/request`, requestData);
    return response.data;
  },

  // Upload customer photos
  uploadPhotos: async (files, requestNumber = null) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    
    const url = requestNumber 
      ? `${API_URL}/upload-photos?request_number=${requestNumber}`
      : `${API_URL}/upload-photos`;
    
    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Get request status and tracking
  getRequestStatus: async (requestNumber) => {
    const response = await axios.get(`${API_URL}/request/${requestNumber}`);
    return response.data;
  },

  // Provider endpoints
  providerLogin: async (credentials) => {
    const response = await axios.post(`${API_URL}/provider/login`, credentials);
    return response.data;
  },

  providerSignup: async (data) => {
    const response = await axios.post(`${API_URL}/provider/signup`, data);
    return response.data;
  },

  getAvailableJobs: async (providerId) => {
    const response = await axios.get(`${API_URL}/provider/available-jobs`, {
      params: { provider_id: providerId }
    });
    return response.data;
  },

  acceptJob: async (providerId, requestNumber) => {
    const response = await axios.post(`${API_URL}/provider/accept-job`, null, {
      params: { provider_id: providerId, request_number: requestNumber }
    });
    return response.data;
  },

  updateProviderLocation: async (providerId, location) => {
    const response = await axios.put(`${API_URL}/provider/location`, location, {
      params: { provider_id: providerId }
    });
    return response.data;
  },

  updateJobStatus: async (providerId, statusUpdate) => {
    const response = await axios.put(`${API_URL}/provider/job-status`, statusUpdate, {
      params: { provider_id: providerId }
    });
    return response.data;
  },

  // Admin endpoints
  getAllRequests: async (status = null) => {
    const params = status ? { status } : {};
    const response = await axios.get(`${API_URL}/admin/requests`, { params });
    return response.data;
  },

  getAllProviders: async () => {
    const response = await axios.get(`${API_URL}/admin/providers`);
    return response.data;
  },

  adminAssignProvider: async (requestNumber, providerId) => {
    const response = await axios.put(`${API_URL}/admin/assign-provider`, null, {
      params: { request_number: requestNumber, provider_id: providerId }
    });
    return response.data;
  },

  adminOverrideStatus: async (requestNumber, status, notes = null) => {
    const response = await axios.put(`${API_URL}/admin/override-status`, null, {
      params: { request_number: requestNumber, status, notes }
    });
    return response.data;
  },

  adminWaiveFee: async (requestNumber, waive) => {
    const response = await axios.put(`${API_URL}/admin/waive-fee`, null, {
      params: { request_number: requestNumber, waive }
    });
    return response.data;
  }
};
